import React, { Suspense } from 'react'
import constants from '../../../../constants'
const RequestCallback = React.lazy(
  () => import('../../../../components/RequestCallback'),
)

const Callback = () => {
  return (
    <section>
      <Suspense fallback={<div>Loading...</div>}>
        <RequestCallback
          careProgramType={constants.CARE_PROGRAM_TYPE.ANAYA}
        ></RequestCallback>
      </Suspense>
    </section>
  )
}

export default Callback
